import { Navigate, Outlet } from "react-router-dom";
import { Flex, Spinner } from "@chakra-ui/react";
import { useAuth } from "@/context/AuthContext";
import { colors } from "@/theme/colors";

// Guards feature routes by role. super_admin is always allowed.
export const RequireRole = ({ allow }) => {
  const { role, isSuperAdmin, dataLoading, isAssigned } = useAuth();

  if (dataLoading) {
    return (
      <Flex minH="50vh" align="center" justify="center">
        <Spinner size="lg" color={colors.teal} borderWidth="3px" />
      </Flex>
    );
  }

  if (isSuperAdmin || (isAssigned && role && allow.includes(role))) {
    return <Outlet />;
  }

  return <Navigate to="/" replace />;
};
